import { array, object, string } from "yup";

export const upcomingReminderValidation = () =>
  object({
    message_text: string().required("Message is required"),
  });
